module.exports = __webpack_public_path__ + "static/img/user_avatar08.565c5cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_avatar08.png
// module id = 7j6+
// module chunks = 1